/**
 * Ficmoon 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * Ficmoon 品牌特定主题配置
 */
export const theme = {
  // 按钮背景色 (Ficmoon 使用 #F6F4FB)
  btnBg: brandTheme.primaryColor,
  // 按钮文本颜色 (Ficmoon 使用主色)
  btnText: brandTheme.textPrimary,
  // 金币颜色 (Ficmoon 使用主色)
  coinsColor: brandTheme.textPrimary,
} as const

/**
 * Ficmoon 品牌特定资源配置
 */
export const resources = {
  // 首页背景图 (Ficmoon 无背景图)
  homeBg: '',
  // 金币图标
  welfareGold: '/images/ficmoon/welfare-gold.png',
  // 宝箱图标
  welfareBox: '/images/ficmoon/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
